import { ReactNode } from 'react';
import { ADMIN_SPACING } from './tokens';

interface AdminPageShellProps {
  header?: ReactNode;
  children: ReactNode;
  /** Width cap. "default" = 7xl (1280), "narrow" = 4xl, "wide" = no cap. */
  width?: 'default' | 'narrow' | 'wide';
  /** Override the default vertical section spacing. */
  noSpacing?: boolean;
  className?: string;
}

/**
 * Consistent page-level wrapper for every admin route.
 *
 * Provides:
 *  - Responsive container with mobile-first padding
 *  - Width control (narrow for settings, wide for tables/dashboards)
 *  - Vertical rhythm via space-y between major sections
 *  - Slot for a sticky-aware page header above the content
 */
export function AdminPageShell({
  header,
  children,
  width = 'default',
  noSpacing = false,
  className = '',
}: AdminPageShellProps) {
  const widthClass =
    width === 'narrow'
      ? 'max-w-4xl'
      : width === 'wide'
        ? 'max-w-none'
        : 'max-w-7xl';

  return (
    <div className={`mx-auto ${widthClass} ${ADMIN_SPACING.page} ${className}`}>
      {header}
      <div className={noSpacing ? '' : ADMIN_SPACING.sectionGap}>{children}</div>
    </div>
  );
}
